import {createClient} from "@sanity/client";

export const sanityClient = createClient({
  projectId: "7f79z3dz",
  dataset: "production",
  apiVersion: "2026-07-12",
  useCdn: true,
  perspective: "published",
});
